'use client';

import { __awaiter, __generator, __spreadArray, __assign } from '../_virtual/_tslib.js';
import { ELanguage } from '../Utils/constants.js';
import React__default, { useState, useEffect } from 'react';
import '../Contexts/translator/index.js';
import translations from './translations.js';
import { Anchor, Paragraph, Label } from '../Typography/components/Variant.js';
import { colors } from '../Colors/index.js';
import Row from '../LayoutSystem/Row.js';
import Col from '../LayoutSystem/Col.js';
import Button from '../Button/index.js';
import { CustomPopup, FooterContainer, BodyContainer, Section, Line, LineDefault, BorderBottom, Note, Image, Detail, BoxInfo, CircleWrapper, ProfileStrength, Circle, HorizonalBorder, LineMatching, TagList } from './style.css.js';
import { matchingJobAPI } from '../services/jobs/index.js';
import LocationIcon from '../Images/LocationIcon/index.js';
import SuitableIcon from '../Images/SuitableIcon/index.js';
import { MATCH_SCORE_SKILL_PERCENT_POINT, MATCH_SCORE_UN_SUITABLE, MATCH_SCORE_VERY_SUITABLE, EMatching } from './const.js';
import VerySuitableIcon from '../Images/VerySuitableIcon/index.js';
import ProficiencyBar from './components/ProficiencyBar.js';
import Tag from '../Tag/index.js';
import { updateSkills } from '../services/resumes/index.js';
import CirclePercent from './components/CirclePercent/index.js';
import { convertDateTime } from '../Utils/time.js';
import { isMobile } from '../Utils/helpers.js';
import { showToast } from '../Toast/index.js';
import trackingJobMatching from '../services/tracking/jobMatching.js';
import useHog from '../PostHog/hooks/useHog/index.js';
import '../UploadResumeModal/type.js';
import { translator } from '../Contexts/translator/helper.js';

var imageUrl = function (matchScore) {
    if (matchScore > MATCH_SCORE_UN_SUITABLE && matchScore < MATCH_SCORE_VERY_SUITABLE) {
        return 'https://images.vietnamworks.com/img/problem-solving.png';
    }
    if (matchScore >= MATCH_SCORE_VERY_SUITABLE) {
        return 'https://images.vietnamworks.com/img/very-matching.png';
    }
    return 'https://images.vietnamworks.com/img/none-matching.png';
};
var JobMatchingAnalysis = function (props) {
    var langCode = props.langCode, isOpen = props.isOpen, onClose = props.onClose, token = props.token, baseMsUrl = props.baseMsUrl, jobInfo = props.jobInfo, _a = props.hiddenApplyBtn, hiddenApplyBtn = _a === void 0 ? false : _a, userId = props.userId;
    var _b = useState(false), isShowPopup = _b[0], setIsShowPopup = _b[1];
    var _c = useState(), matchingJob = _c[0], setMatchingJob = _c[1];
    var _d = useState([]), skillMatchList = _d[0], setSkillMatchList = _d[1];
    var _e = useState([]), skillNoMatchList = _e[0], setSkillNoMatchList = _e[1];
    var _f = useState(0), skillMatching = _f[0], setSkillMatching = _f[1];
    var tracking = useHog().tracking;
    var t = function (txt) {
        return translator(txt, translations, langCode || ELanguage.VI);
    };
    var matchStatusCode = function (matchScore) {
        var score = matchScore !== null && matchScore !== void 0 ? matchScore : 0;
        switch (true) {
            case score < MATCH_SCORE_UN_SUITABLE:
                return EMatching.NOT_MATCHING;
            case score >= MATCH_SCORE_UN_SUITABLE && score < MATCH_SCORE_VERY_SUITABLE:
                return EMatching.MATCHING;
            case score >= MATCH_SCORE_VERY_SUITABLE:
                return EMatching.VERRY_MATCHING;
            default:
                return EMatching.PENDING_FOR_QUERY;
        }
    };
    var getMatchingJob = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _k.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, matchingJobAPI({
                            accessToken: token,
                            langCode: langCode,
                            baseUrl: baseMsUrl,
                            body: {
                                jobId: jobInfo.jobId
                            }
                        })];
                case 1:
                    result = _k.sent();
                    if ((_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.attributes) {
                        setMatchingJob((_b = result === null || result === void 0 ? void 0 : result.data) === null || _b === void 0 ? void 0 : _b.attributes);
                        if ((_d = (_c = result === null || result === void 0 ? void 0 : result.data) === null || _c === void 0 ? void 0 : _c.attributes.matchSkills.notMatchedSkills) === null || _d === void 0 ? void 0 : _d.length) {
                            setSkillNoMatchList(((_e = result === null || result === void 0 ? void 0 : result.data) === null || _e === void 0 ? void 0 : _e.attributes.matchSkills.notMatchedSkills) || []);
                        }
                        setSkillMatchList(((_f = result === null || result === void 0 ? void 0 : result.data) === null || _f === void 0 ? void 0 : _f.attributes.matchSkills.matchedSkills) || []);
                        setSkillMatching(result === null || result === void 0 ? void 0 : result.data.attributes.matchSkills.countMatching);
                        // Tracking view job matching
                        trackingJobMatching(baseMsUrl, {
                            userId: userId,
                            jobId: jobInfo.jobId,
                            action: 'View',
                            status: matchStatusCode((_j = (_h = (_g = result === null || result === void 0 ? void 0 : result.data) === null || _g === void 0 ? void 0 : _g.attributes) === null || _h === void 0 ? void 0 : _h.matchScore) !== null && _j !== void 0 ? _j : 0).toString()
                        });
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _k.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        setIsShowPopup(isOpen);
        if (isOpen && token) {
            tracking({
                eventName: 'js_job_management:job_analysis_view'
            });
            getMatchingJob();
        }
    }, [isOpen, token]);
    // format data
    var msgSkilltext = function () {
        var skillText = t('You possess {numOfSkill} skills required for this job. Add more skills to make your profile more impressive.').replace('{numOfSkill}', "".concat(skillMatching, "/").concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal));
        if (skillMatching === (matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal)) {
            skillText = t('Congratulations! You possess {numOfSkill} skills required for this job.').replace('{numOfSkill}', "".concat(skillMatching, "/").concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal));
        }
        return skillText;
    };
    var matchingStatus = function () {
        if ((matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) === undefined || Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) < MATCH_SCORE_UN_SUITABLE) {
            return '';
        }
        if (Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) >= MATCH_SCORE_UN_SUITABLE &&
            Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) < MATCH_SCORE_VERY_SUITABLE) {
            return (React__default.createElement(LineMatching, { style: { color: colors.green[50] } },
                React__default.createElement(SuitableIcon, { width: 25, height: 25, color: colors.green[50] }),
                React__default.createElement("span", null, matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScoreLabel)));
        }
        if ((matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) >= MATCH_SCORE_VERY_SUITABLE) {
            return (React__default.createElement(LineMatching, { style: { color: colors.primary[40] } },
                React__default.createElement(VerySuitableIcon, { width: 25, height: 25, color: colors.primary[40] }),
                React__default.createElement("span", null, matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScoreLabel)));
        }
        return '';
    };
    var msgCareerPathtext = function () {
        var numOfCriteria = "".concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.countMatching, "/").concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.careerPathTotal);
        return t('This job matches {numOfCriteria} criteria in your career path. Update your profile frequently to let us know your latest career path.').replace('{numOfCriteria}', numOfCriteria);
    };
    var lastUpdated = convertDateTime(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.lastUpdated, 7);
    var removeSkillMatching = function (skill) {
        var skillAddListNew = skillMatchList.filter(function (item) { return item.skillId !== skill.skillId; });
        setSkillMatchList(skillAddListNew);
        setSkillNoMatchList(__spreadArray(__spreadArray([], skillNoMatchList, true), [skill], false));
        setSkillMatching(skillMatching - 1);
        updateSkills(baseMsUrl, token, skill, langCode, 'DELETE');
        showToast(t('Removed successfully'), t('Your Skill has been removed successfully'), 'success');
    };
    var addSkillToMatching = function (skill) { return __awaiter(void 0, void 0, void 0, function () {
        var result, skillNoMatchListNew;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, updateSkills(baseMsUrl, token, __assign(__assign({}, skill), { skillId: -1, skillLevel: 0 }), langCode, 'POST')
                    // Tracking Add skill
                ];
                case 1:
                    result = _b.sent();
                    // Tracking Add skill
                    trackingJobMatching(baseMsUrl, {
                        userId: userId,
                        jobId: jobInfo.jobId,
                        action: 'Add Skill',
                        status: matchStatusCode((_a = matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) !== null && _a !== void 0 ? _a : 0).toString()
                    });
                    if ((result === null || result === void 0 ? void 0 : result.showMessage) === true && (result === null || result === void 0 ? void 0 : result.message) === 'you get maximum skill') {
                        showToast(t('Error: unable to add skills'), t('You had the maximum of skills.'), 'error');
                    }
                    else {
                        setSkillMatchList(__spreadArray(__spreadArray([], skillMatchList, true), [skill], false));
                        skillNoMatchListNew = skillNoMatchList.filter(function (item) { return item.skillId !== skill.skillId; });
                        setSkillNoMatchList(skillNoMatchListNew);
                        setSkillMatching(skillMatching + 1);
                        showToast(t('Added successfully'), t('Your Skill has been added successfully'), 'success');
                        tracking({
                            eventName: 'js_job_management:job_analysis_skill_add',
                            properties: {
                                skillName: skill.skillName
                            }
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var renderTagListMatching = function () {
        if (skillMatchList.length === 0) {
            return null;
        }
        return (React__default.createElement(Detail, { isMobile: isMobile(), style: { marginBottom: skillNoMatchList.length > 0 ? 16 : 0 } },
            React__default.createElement(LineDefault, { style: { margin: '0 0 16px 0', fontWeight: 600 } }, t('Skills on your profile')),
            React__default.createElement(TagList, null, skillMatchList === null || skillMatchList === void 0 ? void 0 : skillMatchList.map(function (skill, index) {
                return (React__default.createElement(Tag, { iconType: 'remove', key: "skill-".concat(skill.skillId, "-").concat(index), isActive: true, label: skill.skillName, onClick: function () {
                        removeSkillMatching(skill);
                    }, size: 'large', isMobile: false, isHiddenIconActive: true }));
            }))));
    };
    var renderTagListNoMatch = function () {
        if (!skillNoMatchList.length) {
            return null;
        }
        return (React__default.createElement(Detail, { isMobile: isMobile() },
            React__default.createElement(LineDefault, { style: { margin: '0 0 16px 0', fontWeight: 600 } }, t('Skills missing on your profile')),
            React__default.createElement(TagList, null, skillNoMatchList.map(function (skill, index) {
                return (React__default.createElement(Tag, { iconType: 'add', key: "add-".concat(skill === null || skill === void 0 ? void 0 : skill.skillId, "-").concat(index), isShowIcon: true, label: skill.skillName, onClick: function () {
                        addSkillToMatching(skill);
                    }, size: 'large', isMobile: false, classSelector: 'add-skill-job-match' }));
            }))));
    };
    var renderTagJobLevelMatching = function () {
        var _a, _b;
        return (React__default.createElement(Detail, { isMobile: isMobile() },
            React__default.createElement(Tag, { isActive: (_a = matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience) === null || _a === void 0 ? void 0 : _a.isMatch, isShowIcon: true, label: "".concat(t('Job level:'), " ").concat((jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelText) || ''), size: 'large', isMobile: false, readOnly: true, custom: ((_b = matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience) === null || _b === void 0 ? void 0 : _b.isMatch)
                    ? {
                        color: colors.primary[40],
                        backgroundColor: colors.primary[95],
                        borderColor: colors.primary[80]
                    }
                    : {
                        color: colors.grey[90],
                        backgroundColor: colors.grey[99],
                        borderColor: colors.grey[90]
                    }, isHiddenIconActive: true })));
    };
    var renderTagCareerPathMatching = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var matchCareerPath = matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath;
        var careerPathList = [
            {
                id: 0,
                name: "".concat(t('Job function'), ": ").concat((_b = (_a = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchJobFunction) === null || _a === void 0 ? void 0 : _a.jobFunction) === null || _b === void 0 ? void 0 : _b.jobFunctionV3Name),
                isMatch: (_c = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchJobFunction) === null || _c === void 0 ? void 0 : _c.isMatch
            },
            {
                id: 1,
                name: "".concat(t('Industry'), ": ").concat((_e = (_d = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchCompanyIndustry) === null || _d === void 0 ? void 0 : _d.industry) === null || _e === void 0 ? void 0 : _e.industryV3Name),
                isMatch: (_f = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchCompanyIndustry) === null || _f === void 0 ? void 0 : _f.isMatch
            },
            {
                id: 2,
                name: "".concat(t('Job title'), ": ").concat((_g = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchJobTitle) === null || _g === void 0 ? void 0 : _g.jobTitle),
                isMatch: (_h = matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchJobTitle) === null || _h === void 0 ? void 0 : _h.isMatch
            },
            {
                id: 3,
                name: t('Working location'),
                isMatch: matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchLocation.isMatch
            },
            {
                id: 4,
                name: t('Salary'),
                isMatch: matchCareerPath === null || matchCareerPath === void 0 ? void 0 : matchCareerPath.matchSalary.isMatch
            }
        ];
        return (React__default.createElement(Detail, { isMobile: isMobile() },
            React__default.createElement(TagList, null, careerPathList.map(function (item, index) {
                var custom = {
                    color: colors.grey[90],
                    backgroundColor: colors.grey[99],
                    borderColor: colors.grey[90]
                };
                if (item.isMatch) {
                    custom = {
                        color: colors.primary[40],
                        backgroundColor: colors.primary[95],
                        borderColor: colors.primary[80]
                    };
                }
                return (React__default.createElement(Tag, { key: "career-".concat(item.id, "-").concat(index), isActive: !!item.isMatch, label: item.name || '', size: 'large', isMobile: false, readOnly: true, custom: custom }));
            }))));
    };
    return (React__default.createElement(CustomPopup, { isShow: isShowPopup, lang: langCode, onClickOutside: function () {
            setIsShowPopup(false);
            onClose && onClose();
        }, onClose: function () {
            setIsShowPopup(false);
            onClose && onClose();
        }, text: {
            header: t('Job matching analysis')
        }, custom: {
            additionalFooterHeight: 40,
            bodyClass: 'vnw-popup-body',
            footer: (React__default.createElement(FooterContainer, { isMobile: isMobile() },
                React__default.createElement(Anchor, { color: colors.primary[40], onClick: function () {
                        return tracking({ eventName: 'js_job_management:job_analysis_update_profile_click' });
                    }, href: '/my-profile', className: 'update-profile-job-match' }, t('Update My profile')),
                !hiddenApplyBtn ? (React__default.createElement(Button, { type: 'primary', onClick: function () {
                        setIsShowPopup(false);
                        onClose && onClose();
                        (props === null || props === void 0 ? void 0 : props.onOpenApplyCallBack) && (props === null || props === void 0 ? void 0 : props.onOpenApplyCallBack());
                        tracking({ eventName: 'js_job_management:job_analysis_apply_click' });
                    }, disabled: false, className: 'apply-job-match' }, t('Apply now'))) : null)),
            withDefaultBody: true
        } },
        React__default.createElement(BodyContainer, null,
            React__default.createElement(Section, null,
                React__default.createElement(Row, null,
                    React__default.createElement(Col, { sm: 14, xs: 24 },
                        React__default.createElement(Line, { name: 'body', size: 'extraLarge', style: { marginBottom: 8 } }, jobInfo.jobTitle),
                        (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.companyUrl) ? (React__default.createElement(Anchor, { style: { fontWeight: 500, fontSize: 14, lineHeight: '18px' }, name: 'body', size: 'small', href: jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.companyUrl, color: colors.primary[40] }, jobInfo.companyName)) : (React__default.createElement(Line, { name: 'body', size: 'small', style: {
                                fontWeight: 500,
                                fontSize: 14,
                                lineHeight: '18px',
                                color: colors.primary[40]
                            } }, jobInfo.companyName)),
                        isMobile() ? (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(LineDefault, { style: { margin: '8px 0', color: colors.secondary[40] } }, jobInfo.prettySalary),
                            React__default.createElement(LineDefault, { style: { margin: '8px 0' } },
                                React__default.createElement(LocationIcon, { width: 24, height: 24 }),
                                React__default.createElement("span", null, (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.locationText) || '')))) : (React__default.createElement(LineDefault, { style: { margin: '8px 0' } },
                            React__default.createElement("span", { style: { color: colors.secondary[40] } }, jobInfo.prettySalary),
                            React__default.createElement("span", null, "|"),
                            React__default.createElement(LocationIcon, { width: 24, height: 24 }),
                            React__default.createElement("span", { style: { maxWidth: '275px' } }, (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.locationText) || ''))),
                        React__default.createElement(BorderBottom, null),
                        matchingStatus(),
                        React__default.createElement(Note, null,
                            "\"",
                            t('The assessment is for reference only, based on your VietnamWorks profile and the requirements of this job.'),
                            "\"")),
                    !isMobile() ? (React__default.createElement(Col, { sm: 10, style: { textAlign: 'center' } },
                        React__default.createElement(Image, { src: imageUrl((matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchScore) || 0), width: 250 }))) : null)),
            React__default.createElement(Section, null,
                React__default.createElement(Row, null,
                    React__default.createElement(Col, null,
                        React__default.createElement(Paragraph, { name: 'label', size: 'medium', color: colors.grey[0], style: { marginBottom: 8 } }, t('Skills')))),
                React__default.createElement(Row, null,
                    React__default.createElement(Col, { sm: 10, xs: 24 },
                        React__default.createElement(Detail, { isMobile: isMobile(), style: { paddingRight: '16px', paddingLeft: 0 } },
                            React__default.createElement(LineDefault, { style: { marginTop: '6px', marginBottom: '8px' } },
                                React__default.createElement(ProficiencyBar, { totalCol: (matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal) || 0, value: skillMatching, background: colors.primary[90], borderRadius: '8px', borderRight: "1px solid ".concat(colors.grey[100]), backgroundSeparator: parseFloat((skillMatching / ((matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchSkills.skillsTotal) || 0)).toFixed(2)) *
                                        100 <=
                                        MATCH_SCORE_SKILL_PERCENT_POINT
                                        ? colors.yellow[40]
                                        : colors.primary[50] })),
                            React__default.createElement(BorderBottom, { style: { width: '100%' } }),
                            React__default.createElement(LineDefault, { style: { margin: '8px 0', fontWeight: 400 } }, msgSkilltext()))),
                    React__default.createElement(Col, { sm: 14, xs: 24 },
                        renderTagListMatching(),
                        renderTagListNoMatch()))),
            React__default.createElement(Section, null,
                React__default.createElement(Row, null,
                    React__default.createElement(Col, null,
                        React__default.createElement(Paragraph, { name: 'label', size: 'medium', color: colors.grey[0], style: { marginBottom: 8 } }, t('Work experience')))),
                React__default.createElement(Row, null,
                    React__default.createElement(Col, { sm: 10, xs: 24 },
                        React__default.createElement(Detail, { isMobile: isMobile(), style: { paddingRight: '16px', paddingLeft: 0 } },
                            React__default.createElement(LineDefault, { style: { marginTop: '6px', marginBottom: '8px' } },
                                React__default.createElement(ProficiencyBar, { totalCol: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience.levelTotal), value: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience.countMatching), background: colors.primary[90], borderRadius: '8px', borderRight: "1px solid ".concat(colors.grey[100]), backgroundSeparator: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchWorkingExperience.percentage) <=
                                        MATCH_SCORE_SKILL_PERCENT_POINT
                                        ? colors.yellow[40]
                                        : colors.primary[50] })),
                            React__default.createElement(BorderBottom, { style: { width: '100%' } }),
                            React__default.createElement(Label, { name: 'body', size: 'medium', color: colors.grey[20], style: { margin: '8px 0' } }, t('Your level vs. required job level.')))),
                    React__default.createElement(Col, { sm: 14, xs: 24 }, renderTagJobLevelMatching()))),
            React__default.createElement(Section, null,
                React__default.createElement(Row, null,
                    React__default.createElement(Col, null,
                        React__default.createElement(Paragraph, { name: 'label', size: 'medium', color: colors.grey[0], style: { marginBottom: 8 } }, t('Career path')))),
                React__default.createElement(Row, null,
                    React__default.createElement(Col, { sm: 10, xs: 24 },
                        React__default.createElement(Detail, { isMobile: isMobile(), style: { paddingRight: '16px', paddingLeft: 0 } },
                            React__default.createElement(LineDefault, { style: { marginTop: '6px', marginBottom: '8px' } },
                                React__default.createElement(ProficiencyBar, { totalCol: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.careerPathTotal), value: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.countMatching), background: colors.primary[90], borderRadius: '8px', borderRight: "1px solid ".concat(colors.grey[100]), backgroundSeparator: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.matchCareerPath.percentage) <=
                                        MATCH_SCORE_SKILL_PERCENT_POINT
                                        ? colors.yellow[40]
                                        : colors.primary[50] })),
                            React__default.createElement(BorderBottom, { style: { width: '100%' } }),
                            React__default.createElement(Label, { name: 'body', size: 'medium', color: colors.grey[20], style: { margin: '8px 0' } }, msgCareerPathtext()))),
                    React__default.createElement(Col, { sm: 14, xs: 24 }, renderTagCareerPathMatching()))),
            React__default.createElement(Section, { isMobile: isMobile() },
                React__default.createElement(Row, null,
                    React__default.createElement(Col, null,
                        React__default.createElement(Paragraph, { name: 'label', size: 'medium', color: colors.grey[0], style: { marginBottom: 8 } }, t('My VietnamWorks profile:')))),
                React__default.createElement(Row, null,
                    React__default.createElement(Col, { sm: 10, xs: 24 },
                        React__default.createElement(Detail, { isMobile: isMobile(), style: { paddingRight: '16px', paddingLeft: 0 } },
                            React__default.createElement(Label, { name: 'body', size: 'medium', color: colors.grey[20], style: { margin: '8px 0' } }, t('A complete and updated profile is more attractive to employers.')))),
                    React__default.createElement(Col, { sm: 14, xs: 24 },
                        React__default.createElement(Detail, { isMobile: isMobile(), style: { display: 'flex', gap: '12px' } },
                            React__default.createElement(BoxInfo, null,
                                React__default.createElement(Label, { size: 'medium' }, t('Profile strength')),
                                React__default.createElement(CircleWrapper, { width: 50 },
                                    React__default.createElement(ProfileStrength, { isMobile: isMobile() }, "".concat(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.profileStrength, "%")),
                                    React__default.createElement(Circle, null,
                                        React__default.createElement(CirclePercent, { percent: 100, width: 50, strokeWidth: 4 })),
                                    React__default.createElement(Circle, null,
                                        React__default.createElement(CirclePercent, { percent: Number(matchingJob === null || matchingJob === void 0 ? void 0 : matchingJob.profileStrength), width: 50, color: '#005AFF', strokeWidth: 4 })))),
                            React__default.createElement(HorizonalBorder, null),
                            React__default.createElement(BoxInfo, null,
                                React__default.createElement(Label, { name: 'body', size: 'medium' },
                                    t('Last update:'),
                                    " ",
                                    lastUpdated)))))))));
};

export { JobMatchingAnalysis as default };
//# sourceMappingURL=index.js.map
